export const POPUPS_TARGET = 'modal-target'

export const CONTAINER = document.querySelector(
    `#${POPUPS_TARGET}`
) as HTMLElement
